import { useEffect, useRef } from "react";

export default function About() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll(".reveal");
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="about"
      ref={sectionRef}
      className="relative py-24 md:py-32 px-4 md:px-8 lg:px-16"
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div>
            <p className="reveal opacity-0 translate-y-6 transition-all duration-700 ease-out text-ding-phosphor font-mono text-sm tracking-widest uppercase mb-4">
              &gt; about
            </p>
            <h2 className="reveal opacity-0 translate-y-6 transition-all duration-700 ease-out delay-100 text-3xl md:text-4xl font-bold font-mono text-ding-cream mb-6">
              Veteran engineer.
              <br />
              <span className="text-ding-phosphor">Practical builder.</span>
            </h2>
            <div className="reveal opacity-0 translate-y-6 transition-all duration-700 ease-out delay-200 space-y-4 text-ding-dim leading-relaxed">
              <p>
                Founded by a veteran engineer with 20+ years shipping realtime networked systems, backend services, and performance-critical production software.
              </p>
            </div>

            <div className="reveal opacity-0 translate-y-6 transition-all duration-700 ease-out delay-300 mt-8 p-6 rounded-xl bg-ding-dark border border-ding-lightgray">
              <p className="text-ding-phosphor font-mono text-lg mb-4">d!ng = 🧑‍💻 &gt; 🤖</p>
              <ul className="text-ding-dim text-sm space-y-2 list-none mb-6">
                <li><span className="text-ding-phosphor mr-2">›</span> augmentation over replacement</li>
                <li><span className="text-ding-phosphor mr-2">›</span> pragmatism over idealism</li>
                <li><span className="text-ding-phosphor mr-2">›</span> engineers lead, agents assist</li>
                <li><span className="text-ding-phosphor mr-2">›</span> intelligence, amplified</li>
                <li><span className="text-ding-phosphor mr-2">›</span> #belikefl</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}